// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"89":"b16216a8","130":"fe95a7ce"}[chunkId] || chunkId) + "." + {"89":"a1aa85b08e01ae36","130":"054a0c5a9e0191b0","468":"11e3ef3f57b346c9","729":"be984c64862f49ca","788":"6bcbf100718f7a90","906":"a111749de32b7a51","969":"e609e783c12dbaf3","979":"42a250c9cdd7c66f"}[chunkId] + ".js";
};